export default "__VITE_ASSET__CvJ7_j5N__"